import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/CapabilitiesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Header.tsx");
